
import React from 'react';
import { Loader } from 'lucide-react';
import { CompressionResult } from '@/types/imageFile';
import { compressorText, Locale } from '@/i18n/compressor';

interface ImageComparisonViewProps {
  originalUrl: string;
  fileName: string;
  compression: CompressionResult;
  isLoadingOriginal: boolean;
  isPremium?: boolean;
  locale?: Locale;
}

const ImageComparisonView = ({
  originalUrl,
  fileName,
  compression,
  isLoadingOriginal,
  isPremium = false,
  locale = 'es'
}: ImageComparisonViewProps) => {
  const t = compressorText[locale].imageComparison;
  return (
    <div className="grid grid-cols-2 gap-0">
      {/* Original Image */}
      <div className="relative aspect-[4/3] bg-gray-100 border-r">
        <div className="absolute top-2 left-2 z-10 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
          {t.original}
        </div>
        {isLoadingOriginal ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader className="w-6 h-6 text-gray-400 animate-spin" />
          </div>
        ) : (
          <img
            src={originalUrl}
            alt={t.originalAlt(fileName)}
            className="w-full h-full object-cover"
          />
        )}
      </div>

      {/* Compressed Image */}
      <div className="relative aspect-[4/3] bg-gray-100">
        <div className={`absolute top-2 left-2 z-10 text-white text-xs px-2 py-1 rounded ${
          isPremium ? 'bg-purple-600' : 'bg-green-600'
        }`}>
          {t.compressed}
        </div>
        <img
          src={compression.compressedUrl}
          alt={t.compressedAlt(fileName)}
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default ImageComparisonView;
